import { render } from "./Greeting.vue?vue&type=template&id=1d53e41a&scoped=true"
import script from "./Greeting.vue?vue&type=script&lang=js"
export * from "./Greeting.vue?vue&type=script&lang=js"

import "./Greeting.vue?vue&type=style&index=0&id=1d53e41a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d53e41a"]])

export default __exports__